export default "__VITE_ASSET__C10ftu5h__"